/* eslint-disable import/prefer-default-export */
import { UserType } from '@centecomm/portal-service';
import { useTenantBusiness } from '@centecomm/portal-service-react';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LoadStatus } from '../../../Types';
import { BusinessActions, BusinessActionTypes } from '../actions';
import { mapBusinessInformationRolesAPIToBusinessRole } from '../Mappers/mapBusinessInformationRolesAPIToBusinessRole';
import * as selectors from '../selectors';
import { Role } from '../Types/Role';

type BusinessRolesFromStateHook = (occupantId: number | string) => {
    areLoaded: boolean;
    areLoading: boolean;
    hasError: boolean;
    loadState: LoadStatus;
    roles: Role[];
};

export const useBusinessRolesFromState: BusinessRolesFromStateHook = (occupantId: number | string) => {
    const dispatch = useDispatch();

    const loadState: LoadStatus = useSelector(selectors.occupantRolesLoadStatus(occupantId));
    const sortedRoles: Role[] = useSelector(selectors.occupantSortedRoleList(occupantId));

    const { getRolesByOccupant } = useTenantBusiness();

    React.useEffect(() => {
        if (loadState === LoadStatus.INITIAL_STATE) {
            dispatch({
                type: BusinessActions.LOAD_BUSINESS_ROLES,
            } as BusinessActionTypes);

            getRolesByOccupant(UserType.Tenant, +occupantId)
                .then((fetchedBusinessRoles) => {
                    dispatch({
                        type: BusinessActions.SET_BUSINESS_ROLES,
                        payload: {
                            occupantId,
                            roles: fetchedBusinessRoles.map((role) => mapBusinessInformationRolesAPIToBusinessRole(role)),
                        },
                    } as BusinessActionTypes);
                })
                .catch((error) => {
                    dispatch({
                        type: BusinessActions.SET_BUSINESS_ROLES_ERROR_STATE,
                        payload: {
                            errorMessage: error?.code
                                ? error.code
                                : 'We were not able to load your business roles at this time.',
                        },
                    });
                });
        }
    }, [loadState]);

    return {
        areLoaded: loadState === LoadStatus.LOADED,
        areLoading: loadState === LoadStatus.PENDING,
        hasError: loadState === LoadStatus.ERROR,
        loadState,
        roles: sortedRoles,
    };
};
